import React, { useContext, useEffect, useState } from "react";
import classNames from "classnames/bind";
import PropTypes from "prop-types";
import { Toast } from "../../../components";
import styles from "./ListLocation.module.css";
import { DownIcon, LeftIcon } from "../../../components/Icons/Icons";
import { reGetNotification } from "../../../store/Actions";
import WareHouse from "./WareHouse";
import { useStoreContext } from "../../../hooks/useStoreContext";
import { Loading } from "../../../components";
import axiosClient from "../../../services/axiosClient";
import { actions } from "../../../store";
import { swapWarehouse } from "../../../utils";
import { CameraContext } from "../../LiveCamera/LiveCamera";
import { useTranslation } from "react-i18next";
const cx = classNames.bind(styles);
const ListLocation = ({
  name,
  wareHouses1,
  icon,
  show,
  onClick,
  value,
  code,
  isGroup,
  filter,
  groupActive,
}) => {
  const [wareHouses, setWareHouse] = useState([]);
  const [warehouse, setWarehouse] = useState([]);
  const [loading, setLoading] = useState(false);
  const [draggedItem, setDraggedItem] = useState();
  const [provinceCode, setProvinceCode] = useState(isGroup ? null : code);
  const [districtCode, setDistrictCode] = useState(null);
  const [communeCode, setCommuneCode] = useState(null);
  const [groupCode, setGroupCode] = useState(isGroup ? code : null);
  const [statusCode, setStatusCode] = useState(null);
  const [dataStore, dispatch] = useStoreContext();
  const { oneThread } = useContext(CameraContext);
  const { t } = useTranslation()
  useEffect(() => {
    if (filter && filter?.length > 0) {
      filter.forEach((item) => {
        switch (item.type) {
          case "group":
            if (item.code) {
              setGroupCode(item.code);
            }
            break;
          case "province":
            if (item.code) {
              setProvinceCode(item.code);
            }
            break;
          case "district":
            setDistrictCode(item.code);
            break;
          case "commune":
            setCommuneCode(item.code);
            break;
          case "status":
            setStatusCode(item.code);
            break;
          default:
            return 0;
        }
      });
    } else if (isGroup) {
      setGroupCode(code);
    } else {
      setProvinceCode(code);
    }
  }, [filter, isGroup, code]);

  const onClicks = async (index) => {
    // setLoading(true);
    // const res = await axiosClient.get(`/warehouse/get-list-warehouse/`, {
    //   params: {
    //     warehouse_name: value,
    //     province_code: provinceCode,
    //     group_code: groupCode,
    //     district_code: districtCode,
    //     commune_code: communeCode,
    //   },
    // });
    setLoading(false);
    // setWareHouse(res);
    onClick(index);
    handleReFreshIndexLocation();
  };

  const handleShowCam = (value) => {
    const data = warehouse.map((item, index) => {
      if (item.code === value) {
        return {
          ...item,
          isShow: !item.isShow,
          icon: !item.isShow ? <DownIcon /> : <LeftIcon />,
        };
      }
      return {
        ...item,
        isShow: false,
        icon: <LeftIcon />,
      };
    });
    setWarehouse(data);
  };
  const onDragStart = (e, item) => {
    setDraggedItem(item);
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/html", e.target.parentNode);
    e.dataTransfer.setDragImage(e.target.parentNode, 20, 20);
  };
  const onDragOver = async (e, code) => {
    try {
      e.preventDefault();
      if (draggedItem) {
        if (draggedItem === code) {
          return;
        }

        const arr = swapWarehouse(wareHouses1, draggedItem, code);
        const data = arr.map((item, index) => {
          return {
            seq: item.SEQ,
            warehouse_code: item.WAREHOUSE_CODE,
          };
        });
        const put = JSON.stringify({ data: data });

        const res = await axiosClient.put(
          "/warehouse/put-change-seq-warehouse/",
          {
            list_warehouse: {
              data: data,
            },
          }
        );
        if (res.result) {
          Toast.open(t("location.changePositionWarehouseSuccess"), "success");
          dispatch(reGetNotification());
        } else {
          Toast.open(t("location.changePositionWarehouseError"), "success");
        }
      }
    } catch (e) {
      Toast.open(t("location.changePositionWarehouseError"), "success");
    }
  };
  const onDragEnd = (code) => {
    // setDraggedItem(null);
  };
  useEffect(() => {
    if (wareHouses1) {
      const data = wareHouses1.map((item, index) => {
        return {
          code: item.WAREHOUSE_CODE,
          name: item.WAREHOUSE_NAME,
          camera: item.LIST_CAMERA,
          isShow: false,
          icon: <LeftIcon />,
          isCheck: false,
          seq: item.SEQ,
        };
      });
      if (data) {
        setWarehouse(data);
      }
    }
  }, [wareHouses1]);

  useEffect(() => {
    const codeLocation = dataStore.wareHouses.indexLocation;
    if (codeLocation && !isGroup) {
      onClicks(codeLocation);
    }
  }, [dataStore.wareHouses.indexLocation, isGroup]);

  const handleReFreshIndexLocation = () => {
    setTimeout(() => {
      dispatch(
        actions.getListCamera({ indexLocation: null, indexWareHouse: null })
      );
    }, 3000);
  };
  return (
    <div className={cx("item")}>
      <div
        style={
          oneThread && groupActive === code ? { background: "rgba(202, 207, 238, 0.2)" } : {}
        }
        onClick={(e) => onClicks(code)}
        className={cx("location")}
      >
        <span className={cx("icon")}>{icon}</span>
        <span className={cx("name")}>{name}</span>
      </div>
      {show && (
        <>
          <div className={cx("warehouse")}>
            {warehouse &&
              warehouse.map((item, index) => (
                <div
                  onDrop={(e) => onDragOver(e, item.code)}
                  onDragOver={(e) => e.preventDefault()}
                >
                  <div
                    draggable={isGroup}
                    onDragStart={(e) => onDragStart(e, item.code)}
                    onDragEnd={(e) => onDragEnd(item.code)}
                    style={{ cursor: isGroup ? "all-scroll" : "pointer" }}
                  >
                    <WareHouse
                      index={index}
                      onClick={handleShowCam}
                      parentShow={show}
                      key={index}
                      show={item.isShow}
                      icon={item.icon}
                      cam={item.camera}
                      name={item.name}
                      setWarehouse={setWarehouse}
                      warehouses={wareHouses1}
                      code={item.code}
                      value={value}
                      status={statusCode}
                      groupCode={groupCode}
                    />
                  </div>
                </div>
              ))}
          </div>
        </>
      )}
    </div>
  );
};


export default React.memo(ListLocation);
